(() => {
  function init(page) {
    if (page.dataset.initialized === 'true') return;
    page.dataset.initialized = 'true';
    const $ = (selector) => page.querySelector(selector);
    const $$ = (selector) => Array.from(page.querySelectorAll(selector));
    const translations = JSON.parse($('[data-ds-translations]').textContent);
    const mobileCopy = JSON.parse($('[data-ds-mobile-translations]')?.textContent || '{}');
    Object.entries(mobileCopy).forEach(([locale, values]) => { if (translations[locale]) Object.assign(translations[locale], values); });
    const supported = ['de', 'ro', 'pt-PT', 'hr', 'hu', 'cs', 'pl'];
    const localeRoots = JSON.parse($('[data-ds-locale-roots]').textContent);
    const localePrefixes = Object.fromEntries(Object.entries(localeRoots).map(([locale, root]) =>
      [locale, new URL(root, location.origin).pathname.replace(/\/$/, '')]));
    const marketLanguage = { DE: 'de', AT: 'de', RO: 'ro', PT: 'pt-PT', HR: 'hr', HU: 'hu', CZ: 'cs', PL: 'pl' };
    const checkoutLanguage = { de: 'DE', ro: 'RO', 'pt-PT': 'PT_PT', hr: 'HR', hu: 'HU', cs: 'CS', pl: 'PL' };
    const approvedMarkets = {
      DE: { currency: 'EUR', price: 89 }, AT: { currency: 'EUR', price: 89 },
      RO: { currency: 'RON', price: 260 }, PT: { currency: 'EUR', price: 49 },
      HR: { currency: 'EUR', price: 49 }, HU: { currency: 'HUF', price: 18000 },
      CZ: { currency: 'CZK', price: 1200 },
      PL: { currency: 'PLN', contextual: true }
    };
    const normalizeLanguage = (locale) => /^pt(?:-|$)/i.test(locale || '') ? 'pt-PT' : (locale || '').split('-')[0];
    const marketAttemptParameter = 'ds_market_attempt';
    const initialUrl = new URL(location.href);
    const isPreview = page.dataset.preview === 'true' || initialUrl.pathname.includes('/products_preview') ||
      initialUrl.searchParams.has('preview_theme_id') || initialUrl.searchParams.has('preview_key');
    const requestedLocale = normalizeLanguage(page.dataset.requestLocale);
    const routeLanguage = supported.includes(requestedLocale) ? requestedLocale : null;
    const preference = (navigator.languages || [navigator.language]).map(normalizeLanguage).find((value) => supported.includes(value));
    const previewLanguage = isPreview ? normalizeLanguage(initialUrl.searchParams.get('lang')) : null;
    const countryParameter = initialUrl.searchParams.get('country')?.toUpperCase();
    const requestedCountry = marketLanguage[countryParameter] ? countryParameter : null;
    const attemptParameter = initialUrl.searchParams.get(marketAttemptParameter)?.toUpperCase();
    const attemptedCountry = marketLanguage[attemptParameter] ? attemptParameter : null;
    // Actual Shopify country stays distinct from language: DE and AT both use German.
    const actualCountry = marketLanguage[page.dataset.marketCountry] ? page.dataset.marketCountry : null;
    const desiredCountry = requestedCountry || attemptedCountry || actualCountry;
    const previewInitialLanguage = supported.includes(previewLanguage) ? previewLanguage : routeLanguage || marketLanguage[actualCountry] || preference || 'de';
    let language = marketLanguage[desiredCountry] || previewInitialLanguage;
    let pending = false;
    let marketPending = false;
    let marketSwitchFailed = false;
    let marketTargetCountry = desiredCountry;
    let marketSubmittedForm = null;
    let marketSubmitAllowed = false;
    let galleryIndex = 0;
    let lastGalleryFocus = null;
    const quantityInput = $('[data-ds-quantity]');
    const quantityNotice = $('[data-person-limit-notice]');
    const quantityPlus = $('[data-person-limit-plus]');
    if (quantityNotice) {
      quantityNotice.hidden = true;
      document.body.append(quantityNotice);
    }
    const personLimitCopy = {
      de: 'Pro Person maximal 1 Stück.',
      ro: 'Maximum 1 bucată de persoană.',
      'pt-PT': 'Máximo de 1 unidade por pessoa.',
      hr: 'Najviše 1 komad po osobi.',
      hu: 'Személyenként legfeljebb 1 darab.',
      cs: 'Maximálně 1 kus na osobu.',
      pl: 'Maksymalnie 1 sztuka na osobę.'
    };
    let quantityNoticeTimer;
    const positionQuantityNotice = () => {
      if (!quantityNotice || quantityNotice.hidden || !quantityPlus) return;
      const viewport = window.visualViewport;
      const viewportLeft = viewport?.offsetLeft || 0;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportWidth = viewport?.width || window.innerWidth;
      const viewportHeight = viewport?.height || window.innerHeight;
      const margin = 12;
      quantityNotice.style.maxWidth = Math.min(340, Math.max(0, viewportWidth - margin * 2)) + 'px';
      const anchor = quantityPlus.getBoundingClientRect();
      const floating = quantityNotice.getBoundingClientRect();
      const above = anchor.top - floating.height - 10;
      const preferredTop = above >= viewportTop + margin ? above : anchor.bottom + 10;
      const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
      quantityNotice.style.left = clamp(anchor.left + anchor.width / 2 - floating.width / 2, viewportLeft + margin, viewportLeft + viewportWidth - floating.width - margin) + 'px';
      quantityNotice.style.top = clamp(preferredTop, viewportTop + margin, viewportTop + viewportHeight - floating.height - margin) + 'px';
    };
    window.addEventListener('resize', positionQuantityNotice, { passive: true });
    window.addEventListener('scroll', positionQuantityNotice, { passive: true, capture: true });
    window.visualViewport?.addEventListener('resize', positionQuantityNotice, { passive: true });
    window.visualViewport?.addEventListener('scroll', positionQuantityNotice, { passive: true });
    const checkoutButton = $('[data-ds-checkout]');
    const checkoutError = $('[data-ds-checkout-error]');
    const variantSelect = $('[data-ds-variant]');
    const countryForms = $$('.ds-market-form');
    const countrySelects = $$('select[data-ds-market-select]');
    const countryDisclosures = [];
    const countryDesktop = window.matchMedia('(min-width:1068px) and (hover:hover) and (pointer:fine)');
    let openedCountryDisclosure = null;
    const mobileMenus = $$('[data-ds-mobile-menu]');
    const marketErrors = $$('[data-ds-market-error]');
    const marketRetries = $$('[data-ds-market-retry]');
    const gallery = $$('[data-ds-gallery-item]');
    const galleryImages = $$('[data-ds-gallery-image]');
    const gallerySlides = $$('[data-ds-gallery-open]');
    const galleryMain = $('[data-ds-gallery-track]');
    const galleryPrevious = $('[data-ds-gallery-inline-prev]');
    const galleryNext = $('[data-ds-gallery-inline-next]');
    const galleryCounter = $('[data-ds-gallery-inline-status]');
    const mobileGallery = window.matchMedia('(max-width: 749px)');
    let galleryGesture = null;
    let suppressGalleryClick = false;
    let galleryScrollFrame = 0;
    let galleryViewportWidth = galleryMain?.clientWidth || 0;
    const lightbox = $('[data-ds-lightbox]');
    const lightboxImage = $('[data-ds-lightbox-image]');
    const copy = () => translations[language] || translations.de;
    const quantity = () => 1;
    if (quantityInput) quantityInput.value = '1';
    const variant = () => variantSelect ? variantSelect.options[variantSelect.selectedIndex] : $('[data-ds-single-variant]');
    // Quantity from incoming links cannot override the store-wide one-item limit.
    const savedVariant = initialUrl.searchParams.get('variant');
    if (variantSelect && savedVariant) {
      const savedOption = Array.from(variantSelect.options).find((option) => option.value === savedVariant);
      if (savedOption) variantSelect.value = savedVariant;
    }

    function updatePriceDisplay() {
      const selected = variant();
      if (!selected) return;
      if (selected.dataset.price) $('[data-ds-price]').textContent = selected.dataset.price;
      const comparison = $('[data-ds-compare-price]');
      const note = $('[data-ds-clearance-note]');
      const row = $('[data-ds-price-row]');
      const clearanceCurrencies = { DE: 'EUR', AT: 'EUR', HR: 'EUR', PT: 'EUR', RO: 'RON', CZ: 'CZK', HU: 'HUF' };
      const clearance = Boolean(clearanceCurrencies[page.dataset.marketCountry]) &&
        clearanceCurrencies[page.dataset.marketCountry] === page.dataset.marketCurrency &&
        Number(selected.dataset.comparePriceAmount) > Number(selected.dataset.priceAmount);
      const compared = clearance || (page.dataset.marketCountry === 'PL' && page.dataset.marketCurrency === 'PLN' &&
        Number(selected.dataset.comparePriceAmount) > Number(selected.dataset.priceAmount));
      row?.classList.toggle('ds-price--clearance', clearance);
      if (comparison) {
        comparison.hidden = !compared;
        comparison.textContent = selected.dataset.comparePrice || '';
        comparison.setAttribute('aria-label', `${comparison.dataset.referenceLabel || row.dataset.referenceLabel}: ${selected.dataset.comparePrice || ''}`);
      }
      if (note) note.hidden = !clearance;
    }

    function updateCheckout() {
      const selected = variant();
      const offer = approvedMarkets[page.dataset.marketCountry];
      const priceCorrect = offer && page.dataset.marketCurrency === offer.currency &&
        (offer.contextual ? Number.isFinite(Number(selected?.dataset.priceAmount)) && Number(selected?.dataset.priceAmount) > 0 :
          Math.abs(Number(selected?.dataset.priceAmount) - offer.price) < 0.005);
      const enabled = page.dataset.checkoutEnabled === 'true' && priceCorrect && selected?.dataset.available === 'true';
      const matchingMarket = page.dataset.marketCountry === desiredCountry && marketLanguage[page.dataset.marketCountry] === language &&
        Object.hasOwn(localePrefixes, language);
      checkoutButton.disabled = !enabled || !matchingMarket || marketSwitchFailed || pending || marketPending;
      checkoutButton.textContent = marketPending ? copy().market_switching || copy().checkout : pending ? copy().checkout_preparing : copy().checkout;
      $$('[data-ds-language]').forEach((button) => { button.disabled = pending || marketPending; });
      marketRetries.forEach((button) => { button.disabled = pending || marketPending; });
      updateCountryDisclosures();
      syncMobileMenus();
      const note = $('[data-ds-gate-note]');
      if (note) {
        const configured = page.dataset.checkoutEnabled === 'true';
        const countrySupported = Boolean(marketLanguage[page.dataset.marketCountry]);
        note.hidden = configured && countrySupported && priceCorrect;
        note.textContent = configured && !countrySupported ? copy().choose_country : configured && !priceCorrect ? copy().market_error : copy().preview_locked;
      }
    }

    function privacyPreferencesApi() {
      if (typeof window.privacyBanner?.showPreferences === 'function') return window.privacyBanner;
      if (typeof window.Shopify?.customerPrivacy?.showPreferences === 'function') return window.Shopify.customerPrivacy;
      return null;
    }
    function refreshCookiePreferences() {
      const key = privacyPreferencesApi() ? 'cookie_preferences' : 'cookie_policy';
      $$('[data-ds-cookie-preferences]').forEach((link) => {
        if (typeof copy()[key] === 'string') link.textContent = copy()[key];
      });
    }

    function setLanguage(next) {
      if (!supported.includes(next)) return;
      language = next;
      page.lang = language;
      document.documentElement.lang = language;
      if (quantityNotice && !quantityNotice.hidden) {
        quantityNotice.textContent = personLimitCopy[language] || personLimitCopy.de;
        positionQuantityNotice();
      }
      $$('[data-i18n]').forEach((node) => {
        const value = copy()[node.dataset.i18n];
        if (typeof value !== 'string') return;
        if (node.hasAttribute('data-i18n-html')) node.innerHTML = value;
        else node.textContent = value;
      });
      $$('[data-block-i18n]').forEach((node) => {
        const [id, field] = node.dataset.blockI18n.split('.');
        const value = copy().blocks[id]?.[field];
        if (typeof value !== 'string') return;
        if (node.hasAttribute('data-i18n-html')) node.innerHTML = value;
        else node.textContent = value;
      });
      $$('[data-ds-spec-rows]').forEach((list) => {
        const rows = copy().blocks[list.dataset.dsSpecRows]?.rows;
        if (typeof rows !== 'string') return;
        list.replaceChildren(...rows.split('\n').filter(Boolean).map((row) => {
          const divider = row.indexOf('|');
          const wrapper = document.createElement('div');
          wrapper.className = 'ds-specs-row';
          const term = document.createElement('dt');
          const value = document.createElement('dd');
          term.textContent = (divider < 0 ? row : row.slice(0, divider)).trim();
          value.textContent = (divider < 0 ? '' : row.slice(divider + 1)).trim();
          wrapper.append(term, value);
          return wrapper;
        }));
      });
      $$('[data-i18n-label]').forEach((node) => {
        const value = copy()[node.dataset.i18nLabel];
        if (value) node.setAttribute('aria-label', value);
      });
      $$('[data-i18n-placeholder]').forEach((node) => {
        const value = copy()[node.dataset.i18nPlaceholder];
        if (typeof value === 'string') node.setAttribute('placeholder', value);
      });
      $$('[data-ds-language]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.dsLanguage === language)));
      const policySlugs = new Set(['shipping-policy', 'refund-policy', 'privacy-policy', 'terms-of-service', 'legal-notice']);
      $$('.ds-footer a[href]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), location.origin);
        const policyPath = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?policies\/([^/]+)\/?$/i);
        if (url.origin !== location.origin || !policyPath || !policySlugs.has(policyPath[1])) return;
        url.pathname = `${localePrefixes[language]}/policies/${policyPath[1]}`;
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
      document.title = `${copy().hero_title} – ${page.dataset.shopName}`;
      if (!checkoutError.hidden) checkoutError.textContent = copy().checkout_error;
      countryForms.forEach((form) => {
        const input = form.querySelector('[name="language_code"]');
        if (input) input.value = language;
      });
      marketErrors.forEach((error) => {
        const message = error.querySelector('[data-ds-market-error-message]');
        if (message) message.textContent = copy().market_error || copy().checkout_error;
      });
      refreshCookiePreferences();
      updatePriceDisplay();
      updateCheckout();
      updateGalleryLabels();
    }

    // Country selectors own localization; there is no language-to-country inference.
    $$('[data-ds-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      quantityInput.value = '1';
      if (button.dataset.dsQuantityChange === '1' && quantityNotice) {
        clearTimeout(quantityNoticeTimer);
        quantityNotice.textContent = personLimitCopy[language] || personLimitCopy.de;
        quantityNotice.hidden = false;
        positionQuantityNotice();
        quantityNoticeTimer = setTimeout(() => {
          quantityNotice.hidden = true;
          quantityNotice.textContent = '';
        }, 3000);
      }
    }));
    quantityInput?.addEventListener('change', () => { quantityInput.value = quantity(); });
    variantSelect?.addEventListener('change', () => {
      updatePriceDisplay();
      updateCheckout();
    });

    function syncCountryControls(countryCode) {
      countrySelects.forEach((select) => {
        select.value = Array.from(select.options).some((option) => option.value === countryCode) ? countryCode : '';
      });
      updateCountryDisclosures();
    }
    function closeCountryDisclosure(disclosure = openedCountryDisclosure, restoreFocus = false) {
      if (!disclosure) return;
      disclosure.wrapper.classList.remove('is-open');
      disclosure.trigger.setAttribute('aria-expanded', 'false');
      disclosure.popover.setAttribute('aria-hidden', 'true');
      disclosure.popover.inert = true;
      disclosure.options.forEach((option) => { option.tabIndex = -1; });
      if (openedCountryDisclosure === disclosure) openedCountryDisclosure = null;
      clearTimeout(disclosure.closeTimer);
      disclosure.closeTimer = setTimeout(() => { disclosure.popover.hidden = true; }, reducedMotion.matches ? 0 : 200);
      if (restoreFocus && !disclosure.trigger.disabled) disclosure.trigger.focus();
    }
    countryDesktop.addEventListener('change', () => { if (!countryDesktop.matches) closeCountryDisclosure(); });
    function openCountryDisclosure(disclosure, focusIndex = null) {
      if (!countryDesktop.matches || pending || marketPending || disclosure.trigger.disabled) return;
      if (openedCountryDisclosure && openedCountryDisclosure !== disclosure) closeCountryDisclosure();
      clearTimeout(disclosure.closeTimer);
      openedCountryDisclosure = disclosure;
      disclosure.popover.hidden = false;
      disclosure.popover.inert = false;
      disclosure.popover.setAttribute('aria-hidden', 'false');
      disclosure.trigger.setAttribute('aria-expanded', 'true');
      disclosure.options.forEach((option) => { option.tabIndex = 0; });
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (openedCountryDisclosure === disclosure) disclosure.wrapper.classList.add('is-open');
        });
      });
      if (focusIndex !== null) disclosure.options[focusIndex]?.focus();
    }
    function updateCountryDisclosures() {
      const blocked = pending || marketPending;
      countryDisclosures.forEach((disclosure) => {
        // Native fields may hold a pending target; visible labels always reflect the real server market.
        const current = Array.from(disclosure.select.options).find((option) => option.value === page.dataset.marketCountry);
        disclosure.label.textContent = current?.textContent.trim() || copy().choose_country_option || copy().choose_country;
        disclosure.trigger.setAttribute('aria-label', copy().country_label ? `${copy().country_label}: ${disclosure.label.textContent}` : disclosure.label.textContent);
        disclosure.popover.setAttribute('aria-label', copy().country_label || disclosure.label.textContent);
        disclosure.trigger.disabled = blocked;
        disclosure.options.forEach((option) => {
          option.disabled = blocked;
          option.setAttribute('aria-current', String(option.dataset.dsMarketCountry === page.dataset.marketCountry));
        });
        if (blocked && openedCountryDisclosure === disclosure) closeCountryDisclosure(disclosure);
      });
    }
    function enhanceCountryControls() {
      countrySelects.forEach((select, index) => {
        const form = select.closest('.ds-market-form');
        const parent = select.parentNode;
        if (!form || !parent || select.closest('.ds-market-disclosure')) return;
        const sourceOptions = Array.from(select.options).filter((option) => marketLanguage[option.value] && !option.disabled);
        if (!sourceOptions.length) return;
        const nativeTabIndex = select.getAttribute('tabindex');
        const nativeAriaHidden = select.getAttribute('aria-hidden');
        const wrapper = document.createElement('div');
        wrapper.className = 'ds-market-disclosure';
        try {
          const trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'ds-market-trigger';
          trigger.setAttribute('aria-expanded', 'false');
          const label = document.createElement('span');
          label.setAttribute('data-ds-market-label', '');
          const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          caret.classList.add('ds-market-caret');
          caret.setAttribute('viewBox', '0 0 10 6');
          caret.setAttribute('width', '10');
          caret.setAttribute('height', '6');
          caret.setAttribute('aria-hidden', 'true');
          caret.setAttribute('focusable', 'false');
          const caretPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          caretPath.setAttribute('d', 'm1 1 4 4 4-4');
          caretPath.setAttribute('fill', 'none');
          caretPath.setAttribute('stroke', 'currentColor');
          caretPath.setAttribute('stroke-width', '1.5');
          caret.append(caretPath);
          trigger.append(label, caret);
          const popover = document.createElement('div');
          popover.className = 'ds-market-popover';
          popover.id = `${select.id || `${page.id || 'deeper-start'}-market-${index}`}-popover`;
          popover.hidden = true;
          popover.inert = true;
          popover.setAttribute('role', 'group');
          popover.setAttribute('aria-hidden', 'true');
          trigger.setAttribute('aria-controls', popover.id);
          const options = sourceOptions.map((sourceOption) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.className = 'ds-market-option';
            option.dataset.dsMarketCountry = sourceOption.value;
            option.tabIndex = -1;
            const text = document.createElement('span');
            text.className = 'ds-market-option-label';
            text.textContent = sourceOption.textContent.trim();
            const check = document.createElement('span');
            check.className = 'ds-market-option-check';
            check.textContent = '✓';
            check.setAttribute('aria-hidden', 'true');
            option.append(text, check);
            popover.append(option);
            return option;
          });
          const disclosure = { wrapper, trigger, label, popover, options, select, closeTimer: null };
          trigger.addEventListener('click', () => {
            if (openedCountryDisclosure === disclosure) closeCountryDisclosure(disclosure);
            else openCountryDisclosure(disclosure);
          });
          options.forEach((option) => option.addEventListener('click', () => {
            if (openedCountryDisclosure !== disclosure || pending || marketPending) return;
            closeCountryDisclosure(disclosure, true);
            if (option.dataset.dsMarketCountry !== page.dataset.marketCountry || marketSwitchFailed) {
              switchCountry(option.dataset.dsMarketCountry, form);
            }
          }));
          wrapper.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && openedCountryDisclosure === disclosure) {
              event.preventDefault();
              event.stopPropagation();
              closeCountryDisclosure(disclosure, true);
              return;
            }
            if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) || pending || marketPending) return;
            if (event.target !== trigger && !options.includes(event.target)) return;
            event.preventDefault();
            const current = options.indexOf(event.target);
            const destination = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
              current < 0 ? (event.key === 'ArrowUp' ? options.length - 1 : 0) :
                (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
            openCountryDisclosure(disclosure, destination);
          });
          wrapper.addEventListener('focusout', (event) => {
            if (!wrapper.contains(event.relatedTarget)) closeCountryDisclosure(disclosure);
          });
          parent.insertBefore(wrapper, select);
          wrapper.append(select, trigger, popover);
          // Hide the native select only after its complete, working replacement is attached.
          select.setAttribute('tabindex', '-1');
          select.setAttribute('aria-hidden', 'true');
          wrapper.classList.add('is-enhanced');
          countryDisclosures.push(disclosure);
        } catch (_error) {
          if (select.parentNode === wrapper) parent.insertBefore(select, wrapper);
          if (nativeTabIndex === null) select.removeAttribute('tabindex');
          else select.setAttribute('tabindex', nativeTabIndex);
          if (nativeAriaHidden === null) select.removeAttribute('aria-hidden');
          else select.setAttribute('aria-hidden', nativeAriaHidden);
          wrapper.remove();
        }
      });
      if (countryDisclosures.length) document.addEventListener('pointerdown', (event) => {
        if (openedCountryDisclosure && !openedCountryDisclosure.wrapper.contains(event.target)) {
          closeCountryDisclosure(openedCountryDisclosure, true);
        }
      });
      updateCountryDisclosures();
    }
    function prepareCountryReturn(form, countryCode) {
      const url = new URL(location.href);
      if (isPreview) {
        url.searchParams.set('lang', language);
      } else if (page.dataset.productHandle) {
        url.pathname = `${localePrefixes[language]}/products/${encodeURIComponent(page.dataset.productHandle)}`;
        url.searchParams.delete('lang');
      }
      url.searchParams.delete('country');
      // A returned marker suppresses another automatic POST if Shopify rejected the market.
      url.searchParams.set(marketAttemptParameter, countryCode);
      const selectedId = variant()?.dataset.gid?.split('/').pop();
      if (/^\d+$/.test(selectedId || '')) url.searchParams.set('variant', selectedId);
      url.searchParams.set('quantity', String(quantity()));
      const returnInput = form.querySelector('[name="return_to"]');
      if (returnInput) returnInput.value = url.pathname + url.search + url.hash;
      const languageInput = form.querySelector('[name="language_code"]');
      if (languageInput) languageInput.value = language;
    }
    function showMarketError(countryCode) {
      marketPending = false;
      marketSubmittedForm = null;
      marketSubmitAllowed = false;
      marketSwitchFailed = true;
      marketTargetCountry = countryCode;
      syncCountryControls(page.dataset.marketCountry);
      marketErrors.forEach((error) => {
        error.hidden = false;
        const message = error.querySelector('[data-ds-market-error-message]');
        if (message) message.textContent = copy().market_error || copy().checkout_error;
      });
      marketRetries.forEach((button) => { button.hidden = !marketLanguage[countryCode]; });
      updateCheckout();
    }
    function prepareMarketSwitch(countryCode, form) {
      if (pending || marketPending) return false;
      const select = form?.querySelector('select[data-ds-market-select]');
      if (!countryForms.includes(form) || !marketLanguage[countryCode] || !select || select.name !== 'country_code' ||
        !Array.from(select.options).some((option) => option.value === countryCode) || !Object.hasOwn(localePrefixes, marketLanguage[countryCode]) ||
        !form.querySelector('[name="language_code"]') || !form.querySelector('[name="return_to"]')) {
        showMarketError(countryCode);
        return false;
      }
      marketTargetCountry = countryCode;
      marketSwitchFailed = false;
      marketErrors.forEach((error) => { error.hidden = true; });
      marketRetries.forEach((button) => { button.hidden = true; });
      setLanguage(marketLanguage[countryCode]);
      syncCountryControls(countryCode);
      prepareCountryReturn(form, countryCode);
      marketPending = true;
      marketSubmittedForm = form;
      updateCheckout();
      return true;
    }
    function switchCountry(countryCode, form = countryForms[0]) {
      if (!prepareMarketSwitch(countryCode, form)) return;
      try {
        // Required localization fields stay enabled so both market and language reach Shopify.
        marketSubmitAllowed = true;
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      } catch (_error) {
        showMarketError(countryCode);
      } finally {
        marketSubmitAllowed = false;
      }
    }
    countryForms.forEach((form) => form.addEventListener('submit', (event) => {
      const countryCode = form.querySelector('select[data-ds-market-select]')?.value;
      if (pending || (marketPending && (!marketSubmitAllowed || marketSubmittedForm !== form || marketTargetCountry !== countryCode))) {
        event.preventDefault();
        return;
      }
      marketSubmitAllowed = false;
      if (!marketPending && !prepareMarketSwitch(countryCode, form)) { event.preventDefault(); return; }
      prepareCountryReturn(form, countryCode);
      queueMicrotask(() => { if (event.defaultPrevented && marketSubmittedForm === form) showMarketError(countryCode); });
    }));
    countrySelects.forEach((select) => select.addEventListener('change', () => switchCountry(select.value, select.closest('.ds-market-form'))));
    marketRetries.forEach((button) => button.addEventListener('click', () => switchCountry(marketTargetCountry, countryForms[0])));

    $$('[data-ds-cookie-preferences]').forEach((link) => link.addEventListener('click', async (event) => {
      const api = privacyPreferencesApi();
      if (!api) return;
      event.preventDefault();
      refreshCookiePreferences();
      try {
        await api.showPreferences();
      } catch (_error) {
        const fallback = new URL(link.getAttribute('href'), location.origin);
        if (fallback.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?policies\/privacy-policy\/?$/i.test(fallback.pathname)) {
          window.location.assign(fallback.href);
        }
      }
    }));
    window.addEventListener('load', refreshCookiePreferences, { once: true });
    window.addEventListener('pageshow', (event) => {
      // A cached document may still contain the previous market's server-rendered prices.
      if (event.persisted) window.location.reload();
    });

    function updateGalleryLabels() {
      if (!gallery.length) return;
      const title = index => index === 0 ? copy().hero_title : `${copy().hero_title} – ${copy().gallery_image} ${index + 1}`;
      galleryImages.forEach((image, index) => { image.alt = title(index); });
      if (lightboxImage) lightboxImage.alt = title(galleryIndex);
      gallery.forEach((button, index) => {
        button.setAttribute('aria-label', `${copy().gallery_image} ${index + 1}`);
        button.setAttribute('aria-current', String(index === galleryIndex));
      });
      gallerySlides.forEach((slide, index) => {
        slide.tabIndex = index === galleryIndex ? 0 : -1;
        slide.setAttribute('aria-label', `${copy().zoom_open} – ${copy().gallery_image} ${index + 1}`);
      });
      const status = $('[data-ds-lightbox-status]');
      if (status) status.textContent = `${galleryIndex + 1} / ${gallery.length}`;
      if (galleryCounter) galleryCounter.textContent = `${galleryIndex + 1} / ${gallery.length}`;
      if (galleryPrevious) galleryPrevious.disabled = galleryIndex === 0;
      if (galleryNext) galleryNext.disabled = galleryIndex === gallery.length - 1;
    }
    function warmGalleryNeighbours() {
      [galleryIndex - 1, galleryIndex + 1].forEach(index => {
        const image = galleryImages[index];
        if (!image) return;
        image.loading = 'eager';
        image.decode?.().catch(() => {});
      });
    }
    function selectGallery(index) {
      galleryIndex = index;
      updateGalleryLabels();
      if (lightboxImage && lightbox && !lightbox.hidden) lightboxImage.src = gallery[index].dataset.fullSrc;
      if (galleryIndex || galleryImages[0]?.complete) warmGalleryNeighbours();
    }
    function alignGallery() {
      if (!galleryMain) return;
      galleryViewportWidth = galleryMain.clientWidth;
      galleryMain.scrollTo({ left: galleryIndex * galleryViewportWidth, behavior: 'instant' });
    }
    function showGallery(index) {
      if (!gallery.length) return;
      selectGallery((index + gallery.length) % gallery.length);
      alignGallery();
    }
    gallery.forEach((button, index) => button.addEventListener('click', () => showGallery(index)));
    function showInlineGallery(index) {
      showGallery(Math.max(0, Math.min(gallery.length - 1, index)));
    }
    galleryPrevious?.addEventListener('click', () => showInlineGallery(galleryIndex - 1));
    galleryNext?.addEventListener('click', () => showInlineGallery(galleryIndex + 1));
    galleryImages[0]?.addEventListener('load', warmGalleryNeighbours, { once: true });
    galleryMain?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? gallery.length - 1 : galleryIndex + (event.key === 'ArrowLeft' ? -1 : 1);
      showInlineGallery(next);
      gallerySlides[galleryIndex]?.focus({ preventScroll: true });
    });
    galleryMain?.addEventListener('scroll', () => {
      if (galleryScrollFrame) return;
      galleryScrollFrame = requestAnimationFrame(() => {
        galleryScrollFrame = 0;
        if (!galleryMain.clientWidth || !gallery.length) return;
        if (galleryMain.clientWidth !== galleryViewportWidth) { alignGallery(); return; }
        const index = Math.max(0, Math.min(gallery.length - 1, Math.round(galleryMain.scrollLeft / galleryMain.clientWidth)));
        if (index !== galleryIndex) selectGallery(index);
      });
    }, { passive: true });
    galleryMain?.addEventListener('pointerdown', event => {
      if (!event.isPrimary) { galleryGesture = null; suppressGalleryClick = true; return; }
      if (event.button !== 0) return;
      suppressGalleryClick = false;
      galleryGesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }, { passive: true });
    galleryMain?.addEventListener('pointermove', event => {
      if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
      if (Math.hypot(event.clientX - galleryGesture.x, event.clientY - galleryGesture.y) > 10) suppressGalleryClick = true;
    }, { passive: true });
    galleryMain?.addEventListener('pointerup', event => {
      if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
      if (Math.hypot(event.clientX - galleryGesture.x, event.clientY - galleryGesture.y) > 10) suppressGalleryClick = true;
      galleryGesture = null;
    }, { passive: true });
    galleryMain?.addEventListener('pointercancel', event => {
      if (!galleryGesture || event.pointerId !== galleryGesture.id) return;
      suppressGalleryClick = true;
      galleryGesture = null;
    }, { passive: true });
    if (galleryMain) {
      new ResizeObserver(() => {
        const currentWidth = galleryMain.clientWidth;
        if (currentWidth && currentWidth !== galleryViewportWidth) alignGallery();
      }).observe(galleryMain);
    }
    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.classList.remove('ds-lock-scroll');
      (gallerySlides[galleryIndex] || lastGalleryFocus)?.focus({ preventScroll: true });
    }
    gallerySlides.forEach((slide, index) => slide.addEventListener('click', event => {
      if (event.detail && suppressGalleryClick) { event.preventDefault(); return; }
      if (!lightbox || !gallery.length) return;
      lastGalleryFocus = slide;
      showGallery(index);
      lightboxImage.src = gallery[index].dataset.fullSrc;
      lightbox.hidden = false;
      document.body.classList.add('ds-lock-scroll');
      $('[data-ds-lightbox-close]').focus();
    }));
    $('[data-ds-lightbox-close]')?.addEventListener('click', closeLightbox);
    $$('[data-ds-lightbox-change]').forEach((button) => button.addEventListener('click', () => showGallery(galleryIndex + Number(button.dataset.dsLightboxChange))));
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showGallery(galleryIndex - 1);
      if (event.key === 'ArrowRight') showGallery(galleryIndex + 1);
      if (event.key === 'Tab') {
        const controls = Array.from(lightbox.querySelectorAll('button:not([hidden])'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function syncMobileMenus() {
      mobileMenus.forEach((menu) => {
        const trigger = menu.querySelector('[data-ds-mobile-menu-trigger]');
        const panel = menu.querySelector('[data-ds-mobile-menu-panel]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', String(menu.open));
        trigger.setAttribute('aria-label', (menu.open ? copy().mobile_menu_close : copy().mobile_menu_open) || copy().mobile_menu_open || 'Menu');
        panel.setAttribute('aria-hidden', String(!menu.open));
        panel.inert = !menu.open;
      });
    }
    function closeMobileMenu(menu, restoreFocus = false) {
      if (!menu.open) return;
      menu.open = false;
      syncMobileMenus();
      if (restoreFocus) menu.querySelector('[data-ds-mobile-menu-trigger]')?.focus();
    }
    mobileMenus.forEach((menu, index) => {
      const trigger = menu.querySelector('[data-ds-mobile-menu-trigger]');
      const panel = menu.querySelector('[data-ds-mobile-menu-panel]');
      if (!trigger || !panel) return;
      if (!panel.id) panel.id = `${page.id || 'deeper-start'}-mobile-menu-${index}`;
      trigger.setAttribute('aria-controls', panel.id);
      menu.addEventListener('toggle', () => {
        if (!mobileGallery.matches) closeMobileMenu(menu);
        syncMobileMenus();
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.open) return;
        event.preventDefault();
        event.stopPropagation();
        closeMobileMenu(menu, true);
      });
      // Native anchor navigation scrolls after the menu closes, preserving the current query and hash behavior.
      Array.from(panel.querySelectorAll('a[href^="#"]')).forEach((link) => link.addEventListener('click', () => closeMobileMenu(menu)));
      document.addEventListener('pointerdown', (event) => {
        if (menu.open && !menu.contains(event.target)) closeMobileMenu(menu);
      });
      const closeOnDesktop = () => { if (!mobileGallery.matches) closeMobileMenu(menu); };
      if (mobileGallery.addEventListener) mobileGallery.addEventListener('change', closeOnDesktop);
      else mobileGallery.addListener?.(closeOnDesktop);
      closeOnDesktop();
    });
    syncMobileMenus();
    $$('[data-ds-accordion]').forEach((details) => {
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    });

    $$('[data-ds-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-ds-track]');
      const cards = Array.from(track.children);
      if (!cards.length) return;
      const previous = carousel.querySelector('[data-ds-slide-prev]');
      const next = carousel.querySelector('[data-ds-slide-next]');
      const status = carousel.querySelector('[data-ds-slide-status]');
      let index = 0;
      let requestedIndex = null;
      const position = (destination) => Math.min(cards[destination].offsetLeft - cards[0].offsetLeft, Math.max(0, track.scrollWidth - track.clientWidth));
      function update() {
        const left = track.scrollLeft;
        const start = cards[0].offsetLeft;
        index = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - start - left) < Math.abs(cards[best].offsetLeft - start - left) ? i : best, 0);
        if (requestedIndex !== null && Math.abs(left - position(requestedIndex)) < 4) requestedIndex = null;
        previous.disabled = requestedIndex === null ? left < 4 : requestedIndex === 0;
        next.disabled = requestedIndex === null ? left >= track.scrollWidth - track.clientWidth - 4 : requestedIndex === cards.length - 1;
        status.textContent = `${index + 1} / ${cards.length}`;
      }
      function move(direction) {
        requestedIndex = Math.max(0, Math.min(cards.length - 1, (requestedIndex ?? index) + direction));
        track.scrollTo({ left: position(requestedIndex), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        update();
      }
      function releaseRequestedIndex() {
        requestedIndex = null;
        update();
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('pointerdown', releaseRequestedIndex, { passive: true });
      track.addEventListener('wheel', releaseRequestedIndex, { passive: true });
      track.addEventListener('keydown', releaseRequestedIndex);
      window.addEventListener('resize', releaseRequestedIndex, { passive: true });
      update();
    });

    checkoutButton?.addEventListener('click', async () => {
      const selected = variant();
      if (page.dataset.checkoutEnabled !== 'true' || checkoutButton.disabled || pending || !selected?.dataset.gid) return;
      pending = true;
      checkoutError.hidden = true;
      updateCheckout();
      try {
        const countryCode = page.dataset.marketCountry;
        const requestedVariant = selected.dataset.gid;
        const requestedQuantity = quantity();
        const query = 'mutation DeeperStartCheckout($input: CartInput!, $language: LanguageCode!, $country: CountryCode!) @inContext(language: $language, country: $country) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity cost { totalAmount { amount currencyCode } } lines(first: 2) { nodes { id quantity merchandise { ... on ProductVariant { id } } } pageInfo { hasNextPage } } } userErrors { message } warnings { code message target } } }';
        const response = await fetch(`/api/${encodeURIComponent(page.dataset.apiVersion)}/graphql.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query, variables: { language: checkoutLanguage[language], country: countryCode, input: { buyerIdentity: { countryCode }, attributes: [{ key: 'expected_delivery_country', value: countryCode }], lines: [{ merchandiseId: requestedVariant, quantity: requestedQuantity }] } } })
        });
        const result = await response.json();
        const created = result?.data?.cartCreate;
        const returnedLines = created?.cart?.lines?.nodes;
        const exactPurchase = created?.cart?.totalQuantity === 1 && requestedQuantity === 1 && Array.isArray(returnedLines) && returnedLines.length === 1 &&
          created.cart.lines.pageInfo?.hasNextPage === false && returnedLines[0].id &&
          returnedLines[0].merchandise?.id === requestedVariant && returnedLines[0].quantity === requestedQuantity;
        if (!response.ok || result.errors?.length || created?.userErrors?.length || created?.warnings?.length ||
          !created?.cart?.checkoutUrl || !exactPurchase || created.cart.cost?.totalAmount?.currencyCode !== page.dataset.marketCurrency) throw new Error('Checkout unavailable');
        // A new Storefront cart isolates this purchase and leaves the existing Ajax cart untouched.
        const destination = new URL(created.cart.checkoutUrl);
        const allowedHosts = new Set([location.hostname, 'eseec.shop', 'ayh08h-3d.myshopify.com']);
        if (destination.protocol !== 'https:' || !allowedHosts.has(destination.hostname) || destination.username || destination.password) throw new Error('Unexpected checkout');
        destination.searchParams.set('locale', language);
        window.location.assign(destination.href);
      } catch (_error) {
        pending = false;
        checkoutError.textContent = copy().checkout_error;
        checkoutError.hidden = false;
        updateCheckout();
      }
    });

    enhanceCountryControls();
    setLanguage(language);
    showGallery(0);
    syncCountryControls(page.dataset.marketCountry);
    const canonicalMarketUrl = new URL(location.href);
    canonicalMarketUrl.searchParams.delete(marketAttemptParameter);
    if (requestedCountry) canonicalMarketUrl.searchParams.delete('country');
    if (canonicalMarketUrl.href !== location.href) history.replaceState(null, '', canonicalMarketUrl);
    const requiresCorrection = page.dataset.marketCountry !== desiredCountry ||
      (!isPreview && desiredCountry && requestedLocale !== language);
    if (requiresCorrection && (!isPreview || requestedCountry || attemptedCountry)) {
      if (attemptedCountry === desiredCountry) showMarketError(desiredCountry);
      else switchCountry(desiredCountry, countryForms[0]);
    }
  }
  document.querySelectorAll('[data-ds-page]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ds-page]').forEach(init));
})();
